module.exports = __webpack_public_path__ + "static/img/SketchPng65d04fa929a2d4fc4f3193bfb6748af4579f103284c3ec0f1fc93b42ab4a4bd9.7054ad28.png";